<template>
    <dropdown-filter
        @change="$emit('input', $event)"
        :value="value"
        label="Search by Service"
        placeholder="Select a Service"
        :options="services"
        :disabled="disabled"
        :loading="loading"
    />
</template>

<script>
import $fetch from 'wee-fetch';
import $mediator from 'wee-mediator';
import DropdownFilter from '../dropdown-filter/index.vue';

export default {
    props: {
        specialty: {
            type: String
        },
        value: {
            type: String,
        },
    },
    components: {
        DropdownFilter,
    },
    watch: {
        specialty(value) {
            if (value && value !== 'Select a Specialty') {
                this.loading = true;

                $fetch.get(`/specialties/${this.specialty}/services.json`)
                    .then(({ data }) => {
                        this.services = data.data.map(item => ({
                            key: item.title,
                            value: item.title,
                        }));

                        if (! this.services.length) {
                            this.services = [];
                        }

                        this.loading = false;
                    }).catch(e => console.error(e));
            } else {
                this.services = [];
                this.$emit('input', '');
            }
        },
    },
    computed: {
        disabled() {
            return ! this.specialty || this.services.length === 0;
        }
    },
    data: () => ({
        services: [],
        loading: false,
    }),
}
</script>
